import { render, staticRenderFns } from "./edit-partner-pricing-product.vue?vue&type=template&id=36c70dcd&scoped=true&"
import script from "./edit-partner-pricing-product.vue?vue&type=script&lang=js&"
export * from "./edit-partner-pricing-product.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner-pricing-product.vue?vue&type=style&index=0&id=36c70dcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c70dcd",
  null
  
)

export default component.exports